import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconCopy = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.00016 12C9.00016 10.3432 10.3433 9.00004 12.0002 9.00004H16.6668C18.3237 9.00004 19.6668 10.3432 19.6668 12V16.6667C19.6668 18.3236 18.3237 19.6667 16.6668 19.6667H12.0002C10.3433 19.6667 9.00016 18.3236 9.00016 16.6667V12ZM12.0002 11C11.4479 11 11.0002 11.4478 11.0002 12V16.6667C11.0002 17.219 11.4479 17.6667 12.0002 17.6667H16.6668C17.2191 17.6667 17.6668 17.219 17.6668 16.6667V12C17.6668 11.4478 17.2191 11 16.6668 11H12.0002ZM6.66683 6.33337C6.48273 6.33337 6.3335 6.48261 6.3335 6.66671V12.6667C6.3335 12.8508 6.48273 13 6.66683 13H7.3335V15H6.66683C5.37816 15 4.3335 13.9554 4.3335 12.6667V6.66671C4.3335 5.37804 5.37817 4.33337 6.66683 4.33337H12.6668C13.9555 4.33337 15.0002 5.37804 15.0002 6.66671V7.33337H13.0002V6.66671C13.0002 6.48261 12.8509 6.33337 12.6668 6.33337H6.66683Z"
        />
      </svg>
    );
  }
);
